var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/split.632f75d1.png","uri@2x": __webpack_public_path__ + "static/media/split.0b35a634.png","uri@3x": __webpack_public_path__ + "static/media/split.d2710966.png",
    width: 25,
    height: 32
});